import { render, staticRenderFns } from "./popUp-Login.vue?vue&type=template&id=0c86f68a&scoped=true"
import script from "./popUp-Login.vue?vue&type=script&lang=js"
export * from "./popUp-Login.vue?vue&type=script&lang=js"
import style0 from "./popUp-Login.vue?vue&type=style&index=0&id=0c86f68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86f68a",
  null
  
)

export default component.exports